import { useMemo } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useConfigStore } from "@companion-core/shared/app/Store/configStore";
import { useMemberData } from "@companion-core/shared/app/Hooks/member";

export const useNewsletterCommon = () => {
  const { config } = useConfigStore();
  const queryClient = useQueryClient();
  const newsletterModule = useMemo(() => config?.modules?.newsletter ?? {}, [config]);
  const myAccountNewsletterModule = useMemo(
    () =>
      config?.modules?.["my-account"]?.modules?.preferences?.forms?.find(
        (element: { name: string }) => element.name === "email",
      ),
    [config],
  );
  const { data } = useMemberData();

  return {
    queryClient,
    newsletterModule,
    myAccountNewsletterModule,
    memberId: data?.id,
  };
};
